import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { EventTypeDto } from '../../models/event-types/eventTypeDto';


@Injectable()
export class EventTypeService extends Service {


    public eventTypes: EventTypeDto[];
    public eventsTypesObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.eventTypes = [];
        this.eventsTypesObject = {};
    }

    public getAll(): Observable<EventTypeDto[]> {
        if (!!this.eventTypes && this.eventTypes.length > 0) {
            return Observable.create((observer: Subscriber<EventTypeDto[]>) => {
                observer.next(this.eventTypes);
                observer.complete();
            });
        }
        const url = 'eventtypes/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.eventTypes = r.Result;
                console.log('this.events', this.eventTypes);
                this.eventsTypesObject = this.eventTypes.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return this.eventTypes;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/event-types/event-type.service.ts